<template lang="pug">
  .expense.pb-12.mb-12
    v-container.white.pt-3.pb-1.px-0(style="max-width:600px;")
      .sticky-header-container(:style="headerHeight")
        .sticky-header(:class="headerClass" )
          div.mb-0.px-4(flat outlined)
            v-row.px-3
              v-col.py-0.pl-0.pr-2()
                v-card( flat outlined)
                  v-card-text.py-2.border-bottom
                    div.c1.primary400--text This Month
                    v-layout
                      div.s2.primary500--text.text-capitalize.mr-1 expense
                      v-tooltip(top color="basic1100" max-width="246px")
                        template(v-slot:activator='{ on }')
                          div.my-auto(v-on='on' style="width:16px; height:16px;")
                            eva-icon(name="info-outline" :fill="$vuetify.theme.themes[$theme].primary500" height="16" width="16")
                        .c1.basic100--text.my-2 {{ $t('tooltip.expense')}}
                    div.h6.primary500--text {{ expensesSummaryMonth? expensesSummaryMonth.total : 0 | displayFormattedPrice($vuetify.breakpoint.width)}}
                  v-card-text.py-2.px-4
                    v-layout
                      div.c1.success500--text.text-capitalize.mr-1 Settled
                      v-tooltip(bottom color="basic1100" max-width="246px")
                        template(v-slot:activator='{ on }')
                          div.my-auto(v-on='on' style="width:16px; height:16px;")
                            eva-icon(name="info-outline" :fill="$vuetify.theme.themes[$theme].success500" height="16" width="16")
                        .c1.basic100--text.my-2 {{ $t('tooltip.settled')}}
                    div.c2.success500--text {{ expensesSummaryMonth? expensesSummaryMonth.total_paid : 0 | displayPrice }}
              v-col.py-0.pl-2.pr-0()
                v-card( flat outlined)
                  v-card-text.py-2.border-bottom
                    div.c1.primary400--text This Year
                    v-layout
                      div.s2.primary500--text.text-capitalize.mr-1 unpaid
                      v-tooltip(top color="basic1100" max-width="246px")
                        template(v-slot:activator='{ on }')
                          div.my-auto(v-on='on' style="width:16px; height:16px;")
                            eva-icon(name="info-outline" :fill="$vuetify.theme.themes[$theme].primary500" height="16" width="16")
                        .c1.basic100--text.my-2 {{ $t('tooltip.unpaid')}}
                    div.h6.primary500--text {{ expensesSummaryYear? expensesSummaryYear.total_unpaid : 0 | displayFormattedPrice($vuetify.breakpoint.width) }}
                  v-card-text.py-2.px-4
                    v-layout
                      div.c1.danger500--text.text-capitalize.mr-1 Overdue
                      v-tooltip(bottom color="basic1100" max-width="246px")
                        template(v-slot:activator='{ on }')
                          div.my-auto(v-on='on' style="width:16px; height:16px;")
                            eva-icon(name="info-outline" :fill="$vuetify.theme.themes[$theme].danger500" height="16" width="16")
                        .c1.basic100--text.my-2 {{ $t('tooltip.overdue')}}
                    div.c2.danger500--text {{ expensesSummaryYear? expensesSummaryYear.total_overdue : 0 | displayPrice }}
            v-row.mt-1(no-gutters align="center")
              v-col.py-2.pr-2
                v-text-field(v-model="searchText" placeholder='Search expense' hide-details dense outlined height="40" background-color="basic200" @focus="searchBarExpand = true" @blur="checkSearch")
                  template(v-slot:append)
                    eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600" )

              v-col.py-1.shrink()
                template(v-if="searchBarExpand")
                  v-btn.elevation-0.pa-0(color="transparent" small icon @click="filterSheet = true")
                    eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
                template(v-else)
                  v-btn.elevation-0.pa-0(text color="transparent" :ripple="false" x-small light @click="filterSheet = true")
                    eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="15" style="margin-top: 2px")
                    .label.primary400--text| Filter
            v-row.no-scrollbar(style="margin:0 -16px;" v-if="Object.keys(filteredData).length > 0" )
              v-container.py-2.px-0(:style="`max-width: 600px; background-color: ${$vuetify.theme.themes[$theme].primary500} !important`")
                div.scrolling-wrapper
                  v-chip.ml-1.py-3(v-if="selectedCategoryFilter" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedCategoryFilter = null; searchItem()") {{ selectedCategoryFilter.name }}
                  v-chip.ml-1.py-3(v-if="selectedStatusFilter" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedStatusFilter = null; searchItem()") {{ selectedStatusFilter.name }}
                  v-chip.ml-1.py-3(v-if="selectedOverdueFilter" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedOverdueFilter = null; searchItem()") {{ selectedOverdueFilter.name }}
                  v-chip.ml-1.py-3(v-if="selectedReminderFilter" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedReminderFilter = null; searchItem()") {{ selectedReminderFilter.name }}
                  v-chip.ml-1.py-3(v-if="selectedDueDate" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedDueDate = null; searchItem()") Due: {{ selectedDueDate | humanizeDate }}
                  v-chip.ml-1.py-3(v-if="selectedDateRangeFilter" color="basic100" close outlined close-icon="mdi-close" small @click:close="selectedDateRangeFilter = null; selectedDateRange = null; searchItem()")
                    template(v-if="selectedDateRangeFilter.id === 'custom' && selectedDateRange.length > 0")
                      template(v-if="selectedDateRange.length > 1") {{ selectedDateRange[0] | humanizeDate }} ~ {{ selectedDateRange[1] | humanizeDate }}
                      template(v-else) {{ selectedDateRange[0] | humanizeDate }}
                    template(v-else) {{ selectedDateRangeFilter.name }}
    v-container.white.py-1.px-0(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout(v-else)
        v-layout.my-6(v-if="expenses.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption Expense not found or empty
        .items-layout(v-else)
          v-card( flat v-for="(expense,index) in expenses" :key="index")
            ExpenseItem(:parentExpense='expense' :isFirstDate='isFirstDate(index)' @deleted="handleDeleteItem" @edited="handleEditItem")
      y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")
    v-btn.mr-3.mb-6(color='textColorAccent' dark fixed bottom right fab height="60" width="60" @click="showAddExpenseDialog = true")
      eva-icon(name="plus-outline" :fill="$vuetify.theme.themes[$theme].basic100" height="24" width="24" style="margin-left: -2px; margin-top: 2px;")

    .modals
      add-expense(v-if="showAddExpenseDialog" :open.sync="showAddExpenseDialog" @added="handleAddItem")
      expense-filter(v-if="filterSheet" :company="company" :filtered="filteredData" :open.sync="filterSheet" @filtered="handleFiltered")

</template>

<script>
import { mapState } from 'vuex'
import queryString from 'query-string'
import AddExpense from '@/components/yezzabook/dialogs/expense/addexpense/AddExpense.vue'
import ExpenseFilter from '@/components/yezzabook/ExpenseFilter.vue'
import ExpenseItem from '@/components/yezzabook/ExpenseItem.vue'

export default {
  name: 'YezzaBookExpense',
  components: { AddExpense, ExpenseItem, ExpenseFilter },
  props: ['company'],
  data: () => ({
    showAddExpenseDialog: false,
    isFetching: false,
    pageSize: 20,
    page: 1,
    count: 0,
    searchText: '',
    expensesSummaryMonth: null,
    expensesSummaryYear: null,
    expenses: [],
    // categories: [],
    filterSheet: false,
    searchBarExpand: false,
    searchCountDown: null,
    selectedFilter: 0,
    searchfilter: '',
    showHeader: true,
    lastScrollPosition: 0,
    loadingCount: 0,
    totalLoadingCount: 0,
    selectedCategoryFilter: null,
    selectedStatusFilter: null,
    selectedOverdueFilter: null,
    selectedReminderFilter: null,
    selectedDateRange: [],
    selectedDueDate: null,
    selectedDateRangeFilter: null,
    customDateRangePickerDialog: false,
    openInvoiceDialog: false,
    openingLead: null
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    // showDetailsTable () {
    //   return this.$vuetify.breakpoint.lgAndUp
    // },
    headerClass() {
      if((!this.showHeader || this.searchText.length > 0) && Object.keys(this.filteredData).length == 0){
        return 'hidden-header'
      }else if((!this.showHeader || this.searchText.length > 0) && Object.keys(this.filteredData).length > 0){
        return 'hidden-header-filtered'
      }else{
        return ''
      }
    },
    headerHeight() {
      if (this.searchText.length > 0 && Object.keys(this.filteredData).length == 0) {
        return 'height:45px'
      }else if(this.searchText.length > 0 && Object.keys(this.filteredData).length > 0) {
         return 'height:76px'
      }else if(this.searchText.length < 1 && Object.keys(this.filteredData).length > 0) {
         return 'height:225px'
      }else{
        return 'height:183px'
      }
    },
    filterParams () {
      let params = {
        page: 1,
        ordering: "-record_date,-id",
        page_size: this.pageSize,
        expand: 'vendor,category,items',
      }
      if (this.searchText && this.searchText.length >= 2 && this.searchText.includes('#')) {
        params.rid = this.searchText.replace('#', '')
      } else if (this.searchText) {
        params.search = this.searchText
      }
      // if (this.member.role !== 'Admin') {
      //   params.member = this.member.id
      // }
      if (this.selectedStatusFilter) {
        if(this.selectedStatusFilter.id == 'paid'){
          params.paid = true
        }else{
          params.paid = false
        }
      }
      if (this.selectedOverdueFilter) {
        if(this.selectedOverdueFilter.id == 'yes'){
          params.overdue = true
        }else{
          params.overdue = false
        }
      }
      if (this.selectedReminderFilter) {
        if(this.selectedReminderFilter.id == 'sent'){
          params.reminder_sent = true
        }else{
          params.reminder_sent = false
        }
      }
      if (this.selectedCategoryFilter) {
        params.category = this.selectedCategoryFilter.id
      }
      if (this.selectedDueDate) {
        params.due_at = this.selectedDueDate
      }
      if (this.selectedDateRangeFilter) {
        if (this.selectedDateRangeFilter.id === 'custom') {
          if (this.selectedDateRange.length === 1) {
            params.record_date_after = this.selectedDateRange[0]
            params.record_date_before = this.selectedDateRange[0]
          } else {
            if (this.selectedDateRange[0] < this.selectedDateRange[1]) {
              params.record_date_after = this.selectedDateRange[0]
              params.record_date_before = this.selectedDateRange[1]
            } else {
              params.record_date_after = this.selectedDateRange[1]
              params.record_date_before = this.selectedDateRange[0]
            }
          }
        } else {
          params.range = this.selectedDateRangeFilter.id
        }
      }
      params.ids = this.expenses.reduce((result, lead)=> {return lead.selected ? result+lead.id + ',' : result}, '')
      return params
    },
    filteredData () {
      let data = {}
      this.selectedCategoryFilter ? data.category = this.selectedCategoryFilter : null
      this.selectedStatusFilter ? data.status = this.selectedStatusFilter : null
      this.selectedOverdueFilter ? data.overdue = this.selectedOverdueFilter : null
      this.selectedReminderFilter ? data.reminder = this.selectedReminderFilter : null
      this.selectedDueDate ? data.duedate = this.selectedDueDate : null
      this.selectedDateRangeFilter ? data.range = this.selectedDateRangeFilter : null
      this.selectedDateRangeFilter ? data.selectedDateRange = this.selectedDateRange : null
      return data
    },
  },
  mounted (){
    if (!this.$route.query.page) {
      this.fetchExpenses(1)
    } else {
      this.fetchExpenses(this.$route.query.page)
    }
    window.addEventListener('scroll', this.onScroll)
    this.fetchExpensesSummary()
    // this.getCategory()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.showHeader = true
        this.fetchExpenses(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    },
    selectedFilter(val) {
      const filter = this.filters[val]
      this.searchfilter = filter.value
      this.searchItem()
    },
    loadingCount (val) {
      if (val) {
        if (val === this.totalLoadingCount) {
          this.isLoading = false
          this.openUpdateStatusDialog = false
          this.openDeleteDialog = false
          this.newStatus = {}
          this.totalLoadingCount = 0
        }
      }
    },
    totalLoadingCount (val) {
      if (!val) {
        this.loadingCount = 0
      }
    },
    isFetching (val) {
      if (val) {
        this.showHeader = true
      }
    }
  },
  methods: {
    fetchExpensesSummary () {
      this.$axios.get(`/books/${this.company.slug}/expenses/summary?span=month`)
        .then((response) => {
          this.expensesSummaryMonth = response.data
        })
        .catch(() => {})
      this.$axios.get(`/books/${this.company.slug}/expenses/summary?span=year`)
        .then((response) => {
          this.expensesSummaryYear = response.data
        })
        .catch(() => {})
    },
    fetchExpenses(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let queryString = Object.keys(this.filterParams).filter((key) => key !== 'page').map(key => key + '=' + this.filterParams[key]).join('&')
      let url = `/books/${this.company.slug}/expenses/?page=${page}&${queryString}`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.expenses = response.data.results
        this.count = response.data.count
      })
      .catch(() => {})
    },
    // getCategory(){
    //   let url = `/books/${this.company.slug}/expense_categories`
    //   this.$axios.get(url).then((response) => {
    //     this.categories = [...response.data.results]
    //   })
    //   .catch(() => {})
    // },
    searchItem () {
      this.isFetching = true
      this.page = 1
      // console.log(this.filterParams);
      this.$axios.get(`/books/${this.company.slug}/expenses/`, { params: this.filterParams })
        .then((response) => {
          this.isFetching = false
          this.expenses = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
    },
    handleFiltered (data) {
      // console.log(data.category)
      this.selectedCategoryFilter = data.category || null
      this.selectedStatusFilter = data.status || null
      this.selectedOverdueFilter = data.overdue || null
      this.selectedReminderFilter = data.reminder || null
      this.selectedDueDate = data.duedate || null
      this.selectedDateRangeFilter = data.range || null
      if (data.range) {
        this.selectedDateRange = data.selectedDateRange
      }
      this.searchItem()
      // this.filteredData = data
    },
    isFirstDate(index){
      var indexBefore = index - 1
      if (indexBefore < 0) {
        return true
      }else{
        var month = this.expenses[index].record_date.toString().split('-')[1]
        var monthBefore = this.expenses[indexBefore].record_date.toString().split('-')[1]
        if (month == monthBefore) {
          return false
        }else{
          return true
        }
      }
    },
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 85) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.showHeader = currentScrollPosition <= this.lastScrollPosition
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    },
    handleAddItem (item) {
      if (item) {
        this.fetchExpenses(1)
      }
      this.fetchExpensesSummary()
    },
    handleEditItem (item) {
      let editIndex = 0
      this.expenses.forEach((expense, index) => {
        if (expense.id === item.id) {
          editIndex = index
        }
      })
      this.expenses = this.expenses.filter((x) => x.id !== item.id)
      this.expenses.splice(editIndex, 0, item)
      this.fetchExpensesSummary()
    },
    handleDeleteItem (item) {
      this.expenses = this.expenses.filter((x) => x !== item)
      this.fetchExpensesSummary()
    },
    checkSearch () {
      if (!this.searchText) {
        this.searchBarExpand = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


<style scoped>
.border-bottom{
    border-bottom: 1px solid var(--v-basic300);
    border-radius: 0 !important;
}
.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  /* height: 183px; */
}
.sticky-header{
  position: fixed;
  transition: 0.3s all ease-out;
  transform: translate3d(0, 0, 0) !important;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
  margin-top: -13px;
  padding-top: 10px;
}
.sticky-header.hidden-header{
    transform: translate3d(0, -70%, 0) !important;
}
.sticky-header.hidden-header-filtered{
    transform: translate3d(0, -60%, 0) !important;
}
@media(min-width: 980px){
  .sticky-header.hidden-header{
    transform: translate3d(0, -70%, 0) !important;
  }
  .sticky-header.hidden-header-filtered{
    transform: translate3d(0, -60%, 0) !important;
}
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

/* custom v-select CSS */

div >>> .v-list-item__title{
  font-size: 15px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white;
}
div >>> .menuable__content__active{
  box-shadow: none !important;
}
div >>> .v-select.v-input--dense .v-select__selection--comma{
  font-size: 15px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
}

/*hide scrollbar */
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
}
</style>

<i18n>
{
  "en": {
    "tooltip": {
      "expense": "Amount of settled and unpaid expenses for this month.",
      "settled": "Amount of payments you have made, including partial payments.",
      "unpaid": "Amount of unpaid expenses, including those overdue and not yet due, for this acccounting year.",
      "overdue": "Amount of unpaid expenses that are past their due date. Make sure to complete your payments."
    }
  }
}
</i18n>